import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-75bad2ba"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bx" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "txt-box" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = { class: "content-box" }

import { useRoute } from 'vue-router';
import { ref } from 'vue';

// import { ISjqnwArticleProps } from '@/api/type';

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const videoData = ref({});
const route = useRoute();
videoData.value = route.query;
console.log(videoData.value);
// const videoData: ISjqnwArticleProps = route.query.type;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("video", {
      src: videoData.value.videoUrl,
      controls: ""
    }, null, 8, _hoisted_2),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("h3", null, _toDisplayString(videoData.value.articleTitle), 1)
      ]),
      _createElementVNode("div", _hoisted_5, _toDisplayString(videoData.value.intro), 1)
    ])
  ]))
}
}

})